import { iOption, iConfigStrikeDate, iConfigFToken, iConfigUToken, zeroBN, iConfigResponse, iClientOrderOption, iOrder } from "../interfaces/interfaces";
import { store } from "../store/store";
import { KasUrl, blockchain, isProduction, monitorUrl, projectName, settingsApi, settingsApi2 } from "../settings";
import { eAppActionTypes } from "../store/app/appTypes";
import { iChrError } from "../interfaces/chrInterfaces";
import { cBigNumber } from "../classes/BigNumber";
import { cStrike } from "../classes/strike";


type tDateFormat =
	'YYYY-MM-DD' |
	'YYYY-MM-DD hh:mm' |
	'YYYY-MM-DD hh:mm:ss' |
	'DDMMMYY' |
	'DDmmmYY' |
	'mmm DD' |
	'YYYY.MM.DD' |
	'DD mmm YY, hh:mm' |
	'DD mmm YYYY, hh:mm' |
	'hh:mm' |
	'hh:mm:ss' |
	'YYYY-MM-DDThh:mm' |
	'YYYY-MM-DDThh:mm:ss'
;
export const getHumanDate = (ts: number, format: tDateFormat): string => {
	if(Number.isNaN(ts)) throw new Error('Error code: 6_9');

	const date = new Date(ts * 1000);

	const year = date.getUTCFullYear().toString();
	const month = (date.getUTCMonth()+1).toString().padStart(2, '0');
	const day = date.getUTCDate().toString().padStart(2, '0');
	const hour = date.getUTCHours().toString().padStart(2, '0');
	const minutes = date.getUTCMinutes().toString().padStart(2, '0');
	const seconds = date.getUTCSeconds().toString().padStart(2, '0');

	const monthNumber = date.getUTCMonth();
	const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
	const monthsCapital = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

	switch (format) {
		case 'YYYY-MM-DD':
			return `${year}-${month}-${day}`;

		case 'YYYY-MM-DD hh:mm':
			return `${year}-${month}-${day} ${hour}:${minutes}`;

		case 'YYYY-MM-DD hh:mm:ss':
			return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;

		case 'DDMMMYY':
			return `${day}${monthsCapital[monthNumber]}${year.slice(-2)}`;

		case 'DDmmmYY':
			return `${day}${months[monthNumber]}${year.slice(-2)}`;

		case 'mmm DD':
			return `${months[monthNumber]} ${day}`;

		case 'YYYY.MM.DD':
			return `${year}.${month}.${day}`;

		case 'DD mmm YY, hh:mm':
			return `${day} ${months[monthNumber]} ${year.slice(-2)}, ${hour}:${minutes}`;

		case 'DD mmm YYYY, hh:mm':
			return `${day} ${months[monthNumber]} ${year}, ${hour}:${minutes}`;

		case 'hh:mm':
			return `${hour}:${minutes}`;

		case 'hh:mm:ss':
			return `${hour}:${minutes}:${seconds}`;

		case 'YYYY-MM-DDThh:mm':
			return `${year}-${month}-${day}T${hour}:${minutes}`;

		case 'YYYY-MM-DDThh:mm:ss':
			return `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;

		default:
			return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
	}
}

export const getHumanDatePeriod = (ts: number): string => {
	const nowTs = store.getState().app.systemTimestamp;
	if (!nowTs) throw new Error('Error code: 6_4')

	const difference = ts - nowTs;

	// (X days/hours/minutes ago - ?)
	if (difference < 0) throw new Error('Error code: 6_5');
	// console.log('now: ', now_ts, '\nts: ', ts, '\ndifference: ', difference)
	return difference < 3600    // less than hour
		? 'in ' + Math.trunc( difference / 60 ) + ' minutes'
		: difference < 86400    // less than day
			? 'in ' + Math.trunc( difference / 60 / 60 ) + ' hours'
			: 'in ' + Math.trunc( difference / 60 / 60 / 24 ) + ' days' // more than day
}

/**
 * Throw the 'e' letter(exponential)
 * @returns formated value
 */
 export const fixExponential = (value: string | number): string => {
	const data = value.toString().split(/[eE]/);
	if (data.length === 1) return data[0];

	let z = '',
		sign = +value < 0 ? '-' : '',
		str = data[0].replace('.', ''),
		mag = Number(data[1]) + 1;

	if (mag < 0) {
		z = sign + '0.';
		while (mag++) z += '0';

		return z + str.replace(/^-/, '');
	}

	mag -= str.length;
	while (mag--) z += '0';

	return str + z;
}

/* export const getTokenByCurrency = (tokenCurrency: string ): tTokenInfo => {
	let res = store.getState().app.tokens.find(token => token.currency === tokenCurrency);
	if (!res) throw new Error(`Error code: 6_2\ncurrency: ${tokenCurrency}`);
	return res;
}
 */
export const getTokenAddrByCurrency = (tokenCurrency: string ): string => {
	let res = store.getState().app.tokens.find(token => token.currency === tokenCurrency);
	if (!res) throw new Error(`Error code: 6_2\ncurrency: ${tokenCurrency}`);
	return res.address;
}

export const getTokenCurrencyByAddr = (tokenAddr: string): string => {
	let res = store.getState().app.tokens.find(token => token.address.toLowerCase() === tokenAddr.toLowerCase());
	if (!res) throw new Error(`Error code: 6_3\naddr: ${tokenAddr} ${res}`);
	return res.currency;
}

/**
 * Works as default, but not rounds.
 */
export const toFixed = (value: string, fixedNumber: number): string => {
	/* if (typeof(value) === 'number'){
		value = value.toString();
	} */
	value = value.replace(/,/, '.'); // replace , to .
	const splitted = value.split('.');
	if (splitted[1]){
		for (let i=1; i<fixedNumber; i++){
			splitted[1] = splitted[1] + '0';
		}
	}
	return splitted.length === 2? splitted[0] + '.' + splitted[1].substring(0, fixedNumber) : splitted[0];
}

export const sortOptions = (a: iOption | iClientOrderOption, b: iOption | iClientOrderOption): number => {
	return (
		b.maturityTime - a.maturityTime ||  // 1 sort: mat_time (newest to oldest)
		// +(a.maturity_time < b.maturity_time) - +(b.maturity_time < a.maturity_time) ||  // 1 sort: mat_time (newest to oldest)   // not causes overflow for big numbers
		+(b.fTokenCurrency < a.fTokenCurrency) - +(a.fTokenCurrency < b.fTokenCurrency) ||  // 2 sort: f_tok (alphabetically)
		+(b.uTokenCurrency < a.uTokenCurrency) - +(a.uTokenCurrency < b.uTokenCurrency) ||  // 3 sort: u_tok (alphabetically)
		// +a.strike.formatted - +b.strike.formatted ||  // 4 sort: strike (smallest to largest)
		+a.strike.initial.sub(b.strike.initial).valueStr ||  // 4 sort: strike (smallest to largest)
		// +(b.strike < a.strike) - +(a.strike < b.strike) ||  // 4 sort: strike (smallest to largest)  // not causes overflow for big numbers
		+b.optionType - +a.optionType     // 5 sort: option_type (call then put)
	)
}

export const filterNonClientOrders = (orders: iOrder[], ): iOrder[] => {
	const { userAddress } = store.getState().app;
	const { chrUserAddress } = store.getState().chromia;
	if ((blockchain === 'binance' && !userAddress) || (blockchain === 'chromia' && !chrUserAddress)) throw new Error();
	return orders.filter(order => order.owner.toLowerCase() !== (blockchain === 'chromia'? chrUserAddress : userAddress)!.toLowerCase());
}

export const getOptionsMaturities = (
	options: iOption[],
	fTokenFilter?: string,
	uTokenFilter?: string,
	optTypeFilter?: 'Call' | 'Put',
	onlyConfigMaturities?: boolean,
): number[] => {

	options = options.filter(option =>
		(
			fTokenFilter
				? option.fTokenCurrency === fTokenFilter
				: true
		) && (
			uTokenFilter
				? option.uTokenCurrency === uTokenFilter
				: true
		) && (
			optTypeFilter
				? option.optionTypeText === optTypeFilter
				: true
		)
	)

	let optionsMaturities: number[] = [];
	for (let option of options){
		!optionsMaturities.includes(option.maturityTime) && optionsMaturities.push(option.maturityTime);
	}

	// remove dates that aren't in config
	if (onlyConfigMaturities){
		const configMaturities = getConfigMaturites();
		optionsMaturities = optionsMaturities.filter( options_maturity => configMaturities.includes(options_maturity));
	}

	return optionsMaturities.sort();
}

export const getConfigMaturites = (): number[] => {
	const config = store.getState().app.config;
	if (!config) throw new Error('Error code: 6_0');
	return config.strikes.dates.map(date => date.ts);
}

export const getOptionsTokens = (token: 'f' | 'u', opts: iOption[]): string[] => {
	console.log('getOptionsTokens opts: ', opts);
	let tokens: string[] = [];
	opts.forEach(opt => {
		const searchingToken = token === 'f' ? opt.fTokenCurrency : opt.uTokenCurrency;
		if (!tokens.includes(searchingToken)) tokens.push(searchingToken);
	})
	return tokens.sort();
}

export const getConfigDate = (ts: number): iConfigStrikeDate => {
	const config = store.getState().app.config;
	if (!config) throw new Error('Error code: 6_11');
	const date = config.strikes.dates.find(date => date.ts === ts);
	if (!date) throw new Error(`Error code: 6_12\nts: ${ts}`);
	return date;
}

export const getConfigFToken = (ts: number, fToken: string): iConfigFToken => {
	const token = getConfigDate(ts).fTokens.find(configFToken => configFToken.currency === fToken);
	if (!token) throw new Error('Error code: 6_13')
	return token;
}

export const getConfigFTokens = (ts: number): string[] => {
	return getConfigDate(ts).fTokens.map(fToken => fToken.currency);
}

export const getConfigUToken = (ts: number, fToken: string, uToken: string): iConfigUToken => {
	const token = getConfigFToken(ts, fToken).uTokens.find(configUToken => configUToken.currency === uToken);
	if (!token) throw new Error('Error code: 6_14')
	return token;
}

export const getConfigUTokens = (ts: number, fToken: string): string[] => {
	return getConfigFToken(ts, fToken).uTokens.map(configUToken => configUToken.currency);
}

export const getConfigStrikes = (ts: number, fToken: string, uToken: string): cStrike[] => {
	return getConfigUToken(ts, fToken, uToken).strikes.map(strike => strike);
}

export const getDecimalsByCurrency = (token: string): number => {
	const currentToken = store.getState().app.tokens.find(tok => tok.currency === token);
	if (!currentToken) throw new Error('Error code: 6_6');
	return currentToken.decimals;
}

export const getOptionInfo = (optId: number, prefix?: string) => {
	const { allOptions } = store.getState().app;

	if (allOptions.length === 0) throw new Error('Error code: 6_8');

	for (let i=0; i<allOptions.length; i++){
		if (allOptions[i].optId === optId){
			const currOpt = allOptions[i];
			return (
				(prefix ? prefix : '') +
				currOpt.uTokenCurrency +
				'-' +
				currOpt.fTokenCurrency +
				' ' +
				currOpt.optionTypeText +
				', maturity: ' +
				getHumanDate(currOpt.maturityTime, 'YYYY-MM-DD') +
				', strike: ' +
				currOpt.strike.formatted
			)
		}
	}
}

/* export const addCloseModalListener = (modalName: tModalName, func: () => void) => {
	document.addEventListener(`close_${modalName}`, func);
} */

/* export const removeCloseModalListener = (modalName: tModalName, func: () => void) => {
	document.removeEventListener(`close_${modalName}`, func);
} */

export const calculateOrderCurrentPrice = (
	orderType: boolean,
	refPrice: cBigNumber,
	delta: cBigNumber,
	orderPrice: cBigNumber,
	minMaxPrice: cBigNumber,
	currentPrice: cBigNumber
): cBigNumber => {
	let fTokPrice: cBigNumber;
	if (!delta.isZero()){    // dynamic order
		// f_tok_price = add_in_BN( order_response.ord_price, multiply_in_BN( substract_in_BN( curr_price, order_response.ref_price ), order_response.delta ) );
		fTokPrice = orderPrice.add(delta.mul(currentPrice.sub(refPrice)));
		// console.log('f_tok_price1: ', fTokPrice);	// check
		// console.log('f_tok_price1: ', f_tok_price, '\nf_tok_price2: ', f_tok_price2);	// check

	} else {    // static order
		fTokPrice = orderPrice;
	}

	return (
		orderType
			? fTokPrice.lt(minMaxPrice)   // sell
				? minMaxPrice      // min
				: fTokPrice
			: fTokPrice.gt(minMaxPrice)   // buy
				? minMaxPrice      // max
				: fTokPrice.gt(zeroBN)
					? fTokPrice
					: new cBigNumber('0.01')
	)
}

export const getApi = async (): Promise<{api: string, config: iConfigResponse, index: number} | undefined> => {
	const apis = [settingsApi, settingsApi2];
	for (let i=0; i < apis.length; i++){
		try{
			let response = await fetch(apis[i] + '/info/');
			if (response.ok) return { api: apis[i], config: await response.json(), index: i };
		} catch {}
	}
}

export const getApiWithBalancer = async (): Promise<{api: string, config: iConfigResponse, index: number} | undefined> => {
	const apis = [settingsApi, settingsApi2];
	let response = await Promise.any( apis.map(async (api, index) => {
		try {
			let response = await fetch(api + '/info/');
			if (response.ok) return { api, response, index };
		} catch {}
	}) );

	return response? { api: response.api, config: await response.response.json(), index: response.index } : undefined;
}

export const connectKAS = async () => {
	const username = 'hello';
	const password = 'world';

	const res = await fetch(KasUrl + 'users/auth', {
			method: 'POST',
			headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: `username=${username}&password=${password}`
	})

	if (res.ok) {
		const accessToken = (await res.json()).access_token;
		store.dispatch({
			type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
			payload: accessToken
		});
	}
}

export const logErrorKas = async (error: string) => {
	switch (blockchain) {
		case 'chromia':
			const err = error as unknown as iChrError;
			if (err.originalError && err.originalError.info && err.originalError.info.error && err.originalError.info.error.code === 4001) return;
	}

	const accessToken =  store.getState().app.KasAccessToken;

	if (isProduction && accessToken) {
		fetch(`${KasUrl}users/send_message?project_name=${projectName}&text=${error}`, {
			method: 'GET',
			headers: {
				'Authorization': `bearer ${accessToken}`
			},
		})
	}

	throw new Error(error);
}

export const logUser = async (address: string) => {
	fetch(monitorUrl + '/accounts', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
		client: address,
		project: "hedget",
		})
	})
}